// extracted by mini-css-extract-plugin
export var text = "_3a-0";